/**
 * A slash command or skill drawn as a chip: in the composer, where clicking
 * it takes the command off, and at the start of the message it was sent in.
 */

import type { CSSProperties } from 'react';
import { Ph } from '../ui';

const CHIP: CSSProperties = {
  height: 22,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  borderRadius: 'var(--radius-xs)',
  background: 'var(--primary-soft)',
  color: 'var(--primary-text)',
  fontFamily: 'var(--font-mono)',
  fontSize: 12.5,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  verticalAlign: 'baseline'
};

export function CommandChip({
  command,
  onRemove,
  style
}: {
  command: string;
  /** Given in the composer: the chip is a button that removes it. */
  onRemove?: () => void;
  style?: CSSProperties;
}) {
  if (!onRemove) {
    return <span style={{ ...CHIP, padding: '0 8px', ...style }}>/{command}</span>;
  }
  return (
    <button
      type="button"
      className="bare"
      aria-label={`Remove /${command}`}
      title="Remove"
      onClick={onRemove}
      style={{ ...CHIP, flex: 'none', padding: '0 6px 0 8px', ...style }}
    >
      /{command}
      <Ph name="x" size={11} />
    </button>
  );
}
